
<script>
  export let height = '100%';
</script>

<div class="scroll-container" style="--height: {height};">
  <slot></slot>
</div>

<style>
  .scroll-container {
    height: var(--height);
    margin-right: -20px; /* +20px to hide scrollbar */
    padding-right: 20px;
    overflow-y: auto;
  }
</style>
